import ReactGA from "react-ga4";

import {
  featureConfig,
  featureFlags,
} from "shell/platform/config/featureFlags";

import { loadAmplitude } from "./analytics/amplitudeLoader";
import { initRUM } from "./analytics/rum";
import { initI18n } from "./i18n";

/**
 * Initializes the globals for the application.
 *
 * This function performs the following steps:
 * 1. Initializes Google Analytics.
 * 2. Initializes the i18n library.
 * 3. Initializes the AWS CloudWatch RUM.
 * 4. Lazily initializes Amplitude when enabled.
 */
export const initGlobals = () => {
  if (featureFlags.enableGoogleAnalytics) {
    try {
      ReactGA.initialize(featureConfig.googleAnalyticsTag);
    } catch (error) {
      console.warn("Failed to initialize Google Analytics", error);
    }
  }

  void initI18n();
  initRUM();
  void initAmplitudeIfEnabled();
};

const initAmplitudeIfEnabled = async () => {
  const amplitude = await loadAmplitude();
  amplitude?.initAmplitude();
};
